module.exports = {
  'yes'   : 'MEDICATIONS.V2.FORM.RADIO.YES',
  'no'    : 'MEDICATIONS.V2.FORM.RADIO.NO',
  'unknown' : 'MEDICATIONS.V2.FORM.RADIO.UNKNOWN'
};
